import primaryComponents from "../../primaryComponents";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { MessageIcon } from "../../../assets/svgIcons/SupplierInviteIcons/MessageIcon";
import {
  SheetIcon,
  PaymentIcon,
  TrackIcon,
  PeriodIcon,
  ReportIcon,
} from "../../../assets/svgIcons/SupplierInviteIcons";
import { useConsentToSupplierContact } from "../../../hooks/api/mutations/useBusiness";
import { useContext } from "react";
import { ToastContext } from "../../../hooks/context";
import { useGetBusinessPotentialReward } from "../../../hooks/api/queries/useBusiness";
import secondaryComponents from "../../secondaryComponents";
import { formatCurrency } from "../../../helpers";

export const BusinessSupplierConsent = ({ closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const { isLoading: isFetchingDetails, data: potentialReward } =
    useGetBusinessPotentialReward();
  const { mutate: consentToSupplier, isLoading } =
    useConsentToSupplierContact();

  const handleConsentToSupplier = () => {
    consentToSupplier(
      { has_consent: true },
      {
        onSuccess: () => {
          triggerToast(
            "Thank you consenting to contact your supplier, You will receive your rewards when supplier subcripe to Lumi",
            "success",
          );
          closeModal();
        },
      },
    );
  };

  return (
    <secondaryComponents.LoaderHelper isLoading={isFetchingDetails}>
      <div className={`${globalStyles.pageColumnGaps} text-center`}>
        <h4 className="px-md-5">
          Invite your suppliers to Lumi Business and get things done faster
        </h4>

        <p
          className={`${globalStyles["statusBlock--success"]} mx-auto default-font-size`}
        >
          {formatCurrency({ value: potentialReward?.amount_per_supplier })} Lumi
          credit per supplier up, {formatCurrency({ value: 250000 })} waiting
          for you.
        </p>

        <div
          className={`${globalStyles.gridDetailsView} text-left px-0`}
          style={{
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          }}
        >
          <div className="d-flex">
            <MessageIcon className="mr-3" />
            <div>
              <h5>Faster communication</h5>
              <p className="small-text-size">Send requests directly in Lumi.</p>
            </div>
          </div>
          <div className="d-flex">
            <TrackIcon className="mr-3" />
            <div>
              <h5>Track orders easily</h5>
              <p className="small-text-size">
                Status of every request in one place.
              </p>
            </div>
          </div>
          <div className="d-flex">
            <PaymentIcon className="mr-3" />
            <div>
              <h5>Payments simplified</h5>
              <p className="small-text-size">
                Link invoices & payments automatically.
              </p>
            </div>
          </div>
          <div className="d-flex">
            <SheetIcon className="mr-3" />
            <div>
              <h5>Stay Supplied, Never Run Out</h5>
              <p className="small-text-size">
                Suppliers see your stock levels & plan supply
              </p>
            </div>
          </div>
          <div className="d-flex">
            <ReportIcon className="mr-3" />
            <div>
              <h5>Better reporting</h5>
              <p className="small-text-size">
                See supplier spend & performance.
              </p>
            </div>
          </div>
          <div className="d-flex">
            <PeriodIcon className="mr-3" />
            <div>
              <h5>Less admin</h5>
              <p className="small-text-size">Save hours every week.</p>
            </div>
          </div>
        </div>

        <primaryComponents.Button
          classNames={"btn btn--primary cover"}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Processing..."}
          onClick={() => handleConsentToSupplier()}
        >
          Claim My Credits & Invite Suppliers
        </primaryComponents.Button>

        <p className="small-text-size">
          By inviting your suppliers, you agree to{" "}
          <a
            href={
              "https://enlumidatainc.zohodesk.com/portal/en/kb/articles/lumi-business-supplier-referral-terms-and-conditions"
            }
            target="_blank"
            className="purple--text small-text-size"
            rel="noreferrer"
          >
            Lumi&apos;s Terms & Conditions.
          </a>
        </p>
      </div>
    </secondaryComponents.LoaderHelper>
  );
};
